<template>
  <div>
    <div v-if="isLoading">loading...</div>
    <Form
      v-else
      :keep-values="true"
      :initial-values="initialValues"
      class="flex flex-col gap-y-3"
      @submit="(values) => onSubmit(values)"
      v-slot="{ errors, values, resetForm, setFieldValue }"
    >
      <Field
        :rules="isRequired"
        name="person.nationalityId"
        v-slot="{ field, errors: errs, handleChange }"
      >
        <SimpleDropdown
          :field="field"
          :errors="errs"
          :label="$t('currentNationality')"
          :options="countries"
          direction="flex-col"
          @on-selection="(item) => handleChange(+item?.code)"
        ></SimpleDropdown>
      </Field>
      <Field
        :rules="isRequired"
        name="person.passportTypeId"
        v-slot="{ field, errors: errs, handleChange }"
      >
        <SimpleDropdown
          :field="field"
          :errors="errs"
          :label="$t('passportTypes')"
          :options="passportTypes"
          direction="flex-col"
          @on-selection="(item) => handleChange(+item?.code)"
        ></SimpleDropdown>
      </Field>
      <Field :rules="isRequired" name="person.passportNumber" v-slot="{ field, errors: errs }">
        <SimpleTextInput
          :field="field"
          :errors="errs"
          :label="$t('passportNumber')"
          direction="flex-col"
        />
      </Field>

      <div class="flex gap-x-4">
        <Field
          :rules="isRequired"
          name="person.dateOfBirth"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDatepicker
            :field="field"
            :errors="errs"
            :label="$t('DateOfBirth')"
            max-date="__now__"
            class="w-1/2"
            @on-change="(date) => handleChange(date)"
          >
          </SimpleDatepicker>
        </Field>
        <Field
          :rules="isNotBlank"
          name="person.genderId"
          v-slot="{ field, errors: errs, handleChange }"
        >
          <SimpleDropdown
            :field="field"
            :errors="errs"
            :label="$t('gender')"
            :options="genders"
            direction="flex-col"
            class="w-1/2"
            @on-selection="(item) => handleChange(item?.code)"
          ></SimpleDropdown>
        </Field>
      </div>
      <Field class="flex-1" name="person.numberOfSponsored" v-slot="{ field, errors: errs }">
        <SimpleTextInput
          :field="field"
          :errors="errs"
          :label="$t('numberOfSponsored')"
          input-type="number"
          direction="flex-col"
        >
          <template #topAppendage>
            <InputAppendage>
              {{ $t('pleaseEnterTheNumberOfPersonsUnderYourSponsorship') }}
            </InputAppendage>
          </template>
        </SimpleTextInput>
      </Field>
      <div class="flex justify-end gap-x-2">
        <button
          class="rounded-md bg-primary/80 hover:bg-primary flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
        >
          <div class="flex justify-center items-center h-full bg-black/10 p-2 rounded-s">
            <faMagnifyingGlass class="w-3 fill-white" />
          </div>
          <span class="px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px]">
            {{ $t('search') }}
          </span>
        </button>
      </div>
    </Form>
  </div>
</template>

<script setup>
import InputAppendage from '@/components/Form/InputAppendage.vue'
import SimpleDatepicker from '@/components/SimpleForm/Datepicker.vue'
import SimpleDropdown from '@/components/SimpleForm/Dropdown.vue'
import SimpleTextInput from '@/components/SimpleForm/TextInput.vue'
import { useLookupsStore } from '@/stores/lookups'
import { Field, Form } from 'vee-validate'
import { onMounted, ref } from 'vue'
import faMagnifyingGlass from '@/assets/icons/faMagnifyingGlass.svg?component'
import axios from '@/services'
import { notify } from 'notiwind'
import { useI18n } from 'vue-i18n'

const lookupsStore = useLookupsStore()

const initialValues = {
  person: {
    numberOfSponsored: 0
  }
}

const i18n = useI18n()
const isLoading = ref(true)
const countries = ref([])
const passportTypes = ref([])
const genders = ref([])

onMounted(async () => {
  countries.value = await lookupsStore.fetchLookup('/api/lookup/countries')
  passportTypes.value = await lookupsStore.fetchLookup('/api/lookup/passportTypes')
  genders.value = await lookupsStore.fetchLookup('/api/lookup/genders')
  isLoading.value = false
})

function isNotBlank(value) {
  return value != null
}

function isRequired(value) {
  if (value && `${value}`.trim()) {
    return true
  }

  return 'INVALID_REQUIRED'
}

async function onSubmit(values) {
  isLoading.value = true

  const otp = 'null'
  const mobileNumber = 0

  try {
    const path = [`/api/User/verifiyAndGenerateQRCode`, otp, mobileNumber, true]
    const payload = {
      ...values.person
    }
    const data = await axios.post(path.join('/'), payload)

    isLoading.value = false

    if (!data.isValid) {
      throw data.messageText
    }
  } catch (error) {
    notify(
      {
        group: 'error',
        text: error
      },
      6000
    )
  }
}
</script>

<style lang="scss" scoped></style>
